import { useGetEmployeeLookupsByRolesQuery } from '@app/main/api';

export interface ActiveCoordinatorIdsResult {
  ids: string[] | undefined;
  isLoading: boolean;
}

export function useActiveCoordinatorIds(): ActiveCoordinatorIdsResult {
  const { data, isLoading } = useGetEmployeeLookupsByRolesQuery({
    roles: ['COORDINATOR'],
    onlyActive: true,
  });

  return {
    ids: data?.map((x) => x.id),
    isLoading,
  };
}
